import $ from "jquery";
// import ui from 'jquery-ui'

export default function () {
    $("[data-accordion]").accordion({
        header: "[data-accordion-title]",
        heightStyle: "content",
        // icons: { "header": "ui-icon-plus", "activeHeader": "ui-icon-minus" },
        icons: false,
        // animate: 'ease-in',
        // animated: false,
        active: false,
        // event: "",
        collapsible: true,
        // alwaysOpen: false,
        // activate: 0,
        // changestart: function (event, ui) {
        //     // console.log(ui)
        //     if ($(this).hasClass('effect-none')) {
        //         ui.options.animated = false;
        //     }
        //     else {
        //         ui.options.animated = 'slide';
        //     }
        // },
        beforeActivate: function (event, ui) {
            // console.log(ui)
            let $bodyScrollTop = $("body,html").scrollTop();
            // console.log($bodyScrollTop)

            // TODO uncomment this for some scroll fix
            // setTimeout(function() {
            //     $('body,html').animate({ scrollTop: $bodyScrollTop });
            // }, 1); // ensure the collapse animation is done

            // let panel = ui.newPanel.length === 0 ? ui.oldPanel : ui.newPanel
            // let $accordionGroup = panel.closest('[data-block="acf/vertical-accordion-itemn-group"]')
            // let $oldAccordionItem = null
            // let $newAccordionItem = null
            // let $oldAccordionItem = ui.oldPanel.length ? $(ui.oldPanel[0]).closest('[data-block="acf/accordion-item"]') : null
            // let $newAccordionItem = ui.newPanel.length ? $(ui.newPanel[0]).closest('[data-block="acf/accordion-item"]') : null

            console.log($(this).data("accordion-multiple-open"));

            if ($(this).data("accordion-multiple-open") === 1) {
                //console.log("test1");

                if (ui.newHeader[0]) {
                    var currHeader = ui.newHeader;
                    var currContent = currHeader.next(".ui-accordion-content");
                    // The accordion believes a panel is being closed
                } else {
                    var currHeader = ui.oldHeader;
                    var currContent = currHeader.next(".ui-accordion-content");
                }
                // Since we've changed the default behavior, this detects the actual status
                var isPanelSelected =
                    currHeader.attr("aria-selected") == "true";

                // Toggle the panel's header
                currHeader
                    .toggleClass("ui-corner-all", isPanelSelected)
                    .toggleClass(
                        "accordion-header-active ui-state-active ui-corner-top",
                        !isPanelSelected,
                    )
                    .attr("aria-selected", (!isPanelSelected).toString());

                // Toggle the panel's icon
                currHeader
                    .children(".ui-icon")
                    .toggleClass("ui-icon-triangle-1-e", isPanelSelected)
                    .toggleClass("ui-icon-triangle-1-s", !isPanelSelected);

                // Toggle the panel's content
                currContent.toggleClass(
                    "accordion-content-active",
                    !isPanelSelected,
                );
                if (isPanelSelected) {
                    currContent.slideUp();
                } else {
                    currContent.slideDown();
                }

                return false; // Cancels the default action
            } else {
                //console.log("test 2");

                let $oldAccordionItem = ui.oldPanel.length
                    ? $(ui.oldPanel[0]).closest("[data-accordion-block]")
                    : null;
                let $newAccordionItem = ui.newPanel.length
                    ? $(ui.newPanel[0]).closest("[data-accordion-block]")
                    : null;
                /*console.log({ $oldAccordionItem });
                console.log({ $newAccordionItem });
                console.log($(ui.newPanel[0]));*/

                if ($oldAccordionItem) {
                    //console.log("weg");
                    let $oldAccordionAffected = $(
                        `[data-accordion-affected]`,
                        $oldAccordionItem,
                    ); //=${accordionId}]

                    $oldAccordionAffected.each(function () {
                        let accordionInActiveClasses =
                            $(this).data("accordion-inactive-class") || "";
                        let accordionInActiveRemoveClasses =
                            $(this).data("accordion-inactive-remove-class") ||
                            "";

                        $(this).removeClass(accordionInActiveRemoveClasses);
                        $(this).addClass(accordionInActiveClasses);
                    });
                }

                if ($newAccordionItem) {
                    let $newAccordionAffected = $(
                        `[data-accordion-affected]`,
                        $newAccordionItem,
                    ); //=${accordionId}]

                    // console.log({$newAccordionAffected})
                    $newAccordionAffected.each(function () {
                        let accordionActiveClasses =
                            $(this).data("accordion-active-class") || "";
                        let accordionActiveRemoveClasses =
                            $(this).data("accordion-active-remove-class") || "";

                        $(this).removeClass(accordionActiveRemoveClasses);
                        $(this).addClass(accordionActiveClasses);
                    });
                }
            }
        },
        activate: function (event, ui) {
            // console.log(ui)

            let $bodyScrollTop = $("body,html").scrollTop();
            // console.log('activate')
            // console.log($bodyScrollTop)
            // if (ui.newHeader.offset()) {
            //     $('body,html').animate({ scrollTop: ui.newHeader.offset().top - 80 });
            // }
        },
    });
}
